import { Search } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const sortOptions = [
  { value: "featured", label: "Featured" },
  { value: "newest", label: "Newest" },
  { value: "oldest", label: "Oldest" },
];

// Search + category chips + sort. Shared by every collection so adding content
// never changes the interaction model.
export default function CollectionToolbar({
  collection,
  searchPlaceholder = "Search...",
  showSort = true,
  testidPrefix = "collection",
}) {
  const { query, setQuery, category, setCategory, categories, sort, setSort, total } =
    collection;

  return (
    <div>
      <Reveal>
        <div className="flex flex-col lg:flex-row lg:items-center gap-3">
          <div className="relative flex-1 max-w-xl">
            <Search
              size={18}
              className="absolute left-4 top-1/2 -translate-y-1/2 text-zinc-500"
            />
            <input
              data-testid={`${testidPrefix}-search`}
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder={searchPlaceholder}
              className="w-full bg-ink-surface border border-white/10 text-white pl-11 pr-4 py-3.5 focus:outline-none focus:border-burnt placeholder:text-zinc-600"
            />
          </div>
          {showSort && (
            <div className="flex items-center gap-2">
              {sortOptions.map((o) => (
                <button
                  key={o.value}
                  data-testid={`${testidPrefix}-sort-${o.value}`}
                  onClick={() => setSort(o.value)}
                  className={`px-3.5 py-2 text-xs uppercase tracking-[0.12em] border transition-colors ${
                    sort === o.value
                      ? "border-white/40 text-white"
                      : "border-white/10 text-zinc-500 hover:text-white"
                  }`}
                >
                  {o.label}
                </button>
              ))}
            </div>
          )}
        </div>
      </Reveal>

      <Reveal>
        <div className="mt-6 flex flex-wrap gap-2">
          {categories.map((c) => (
            <button
              key={c}
              data-testid={`${testidPrefix}-filter-${String(c).toLowerCase().replace(/\s+/g, "-")}`}
              onClick={() => setCategory(c)}
              className={`px-4 py-2 text-sm font-medium transition-colors border ${
                category === c
                  ? "bg-burnt border-burnt text-white"
                  : "bg-transparent border-white/15 text-zinc-400 hover:border-white/40 hover:text-white"
              }`}
            >
              {c}
            </button>
          ))}
        </div>
      </Reveal>

      <p
        data-testid={`${testidPrefix}-count`}
        className="mt-6 text-sm text-zinc-500"
      >
        {total} {total === 1 ? "item" : "items"}
      </p>
    </div>
  );
}
